export default function DeclaratiiPage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
          <a
            href="/documente/declaratii/Declaratii_de_interes.PDF"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xl font-bold mt-8 mb-4"
          >
            Declarații de interes
        </a>
        <h2 className="text-xl font-bold mt-8 mb-4">Declarații de avere</h2>
      </main>
    </div>
  );
}
